import React from 'react';

const CircleRightIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.0003 1.6665C5.40866 1.6665 1.66699 5.40817 1.66699 9.99984C1.66699 14.5915 5.40866 18.3332 10.0003 18.3332C14.592 18.3332 18.3337 14.5915 18.3337 9.99984C18.3337 5.40817 14.592 1.6665 10.0003 1.6665ZM12.3253 10.4415L9.38366 13.3832C9.25866 13.5082 9.10033 13.5665 8.94199 13.5665C8.78366 13.5665 8.62533 13.5082 8.50033 13.3832C8.25866 13.1415 8.25866 12.7415 8.50033 12.4998L11.0003 9.99984L8.50033 7.49984C8.25866 7.25817 8.25866 6.85817 8.50033 6.6165C8.74199 6.37484 9.14199 6.37484 9.38366 6.6165L12.3253 9.55817C12.5753 9.79984 12.5753 10.1998 12.3253 10.4415Z'
        fill='white'
      />
    </svg>
  );
};

export default CircleRightIcon;
